module.exports = __webpack_public_path__ + "img/92.6f64a78d.jpg";